// extracted by mini-css-extract-plugin
export default {"card":"a5-z","carouselContainer":"b5-z","carouselContent":"c5-z"};